// services/billingInvoices.js — invoicing in Cortex, one project at a time (2026-11-04).
// api/billing-invoices.js; docs/BILLING_INVOICE_STUDY.md "The per-project review".

async function token() { return window.__clerkGetToken ? await window.__clerkGetToken() : null }

async function call(method, qsOrBody) {
  const t = await token()
  const headers = t ? { Authorization: 'Bearer ' + t } : {}
  let res
  if (method === 'GET') res = await fetch('/api/billing-invoices?' + qsOrBody, { headers })
  else res = await fetch('/api/billing-invoices', { method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify(qsOrBody) })
  let j = null
  try { j = await res.json() } catch (e) {}
  if (!res.ok) throw new Error((j && j.error) || ('Request failed: ' + res.status))
  return j
}

export const getReview = (code, through) =>
  call('GET', 'action=review&through=' + encodeURIComponent(through) + '&code=' + encodeURIComponent(code))
export const adjustEntry = (o) => call('POST', { action: 'adjust', ...o })
export const editEntry = (o) => call('POST', { action: 'editEntry', ...o })
export const setPhasePercent = (o) => call('POST', { action: 'setPercent', ...o })
export const sendInvoice = (o) => call('POST', { action: 'send', ...o })

export async function getLedgerPdf(id) {
  const t = await token()
  const res = await fetch('/api/billing-invoices?action=pdf&id=' + encodeURIComponent(id), { headers: t ? { Authorization: 'Bearer ' + t } : {} })
  if (!res.ok) throw new Error('No PDF stored for that invoice.')
  return res.blob()
}

const r2 = n => Math.round((Number(n) || 0) * 100) / 100

/**
 * The same rules as api/_invoiceBuild.js#draftLine, run in the browser so every edit shows at once.
 * Fixed fee: contract x percent - billed before, capped at the contract, spread evenly over the hours
 * billed. Hourly: each entry at its rate after its own write-up/down. Excluded entries stay out;
 * written-off ones bill nothing.
 */
export function computePhase(phase, time, expenses) {
  const t = time.filter(x => x.phaseId === phase.id && x.choice !== 'exclude')
  const e = expenses.filter(x => x.phaseId === phase.id && x.choice !== 'exclude')
  const hoursOf = x => (x.clientHours != null ? x.clientHours : x.actualHours) || 0
  let standard = 0, billedHourly = 0, hours = 0
  for (const x of t) {
    const v = hoursOf(x) * x.billRate
    hours += hoursOf(x)
    if (x.choice === 'write_off') continue
    standard += v
    billedHourly += v * (1 + (Number(x.wud) || 0) / 100)
  }
  const exp = r2(e.reduce((s, x) => s + (x.choice === 'write_off' ? 0 : x.amount), 0))
  const out = { hours: r2(hours), standard: r2(standard), expenses: exp, notes: [] }
  if (phase.kind === 'fixed') {
    const c = phase.contract || 0, pct = phase.percent
    if (!(c > 0)) { out.service = 0; out.notes.push('No contract amount') }
    else if (pct == null) { out.service = 0; out.notes.push('No percent complete set') }
    else {
      const earned = r2(c * pct / 100), room = r2(c - phase.billedBefore)
      const raw = r2(earned - phase.billedBefore)
      out.service = r2(Math.max(0, Math.min(raw, room)))
      if (raw > room + 0.005) out.notes.push('Stopped at the contract')
    }
    out.wud = standard > 0.005 ? (out.service > 0.005 ? Math.round((out.service / standard - 1) * 1000) / 10 : -100) : null
  } else {
    out.service = r2(billedHourly)
  }
  out.total = r2(out.service + out.expenses)
  out.billedAfter = r2(phase.billedBefore + out.service)
  out.over = phase.kind === 'fixed' && phase.contract > 0 && out.billedAfter > phase.contract + 0.005
  return out
}
